import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Container,
  Grid,
  MenuItem,
  Select,
  FormControl,
  Snackbar,
  Alert,
  Checkbox,
  FormControlLabel,
  InputLabel,
} from '@mui/material';
import SelectField from '../../../components/ui/basicSelectInput';
import {
  DataGridPro,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from '@mui/x-data-grid-pro';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ValidatorForm } from 'react-material-ui-form-validator';
import ValidatedDatePicker from '../../../components/ui/DatePicker';
import moment from 'moment';
import axios from '../../../axios-order';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import { canWrite } from '../../../utils/privilegeUtils'

// Custom NoRowsOverlay component
const CustomNoRowsOverlay = () => {
  console.log('Rendering CustomNoRowsOverlay');
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        fontSize: '16px',
        fontWeight: 'medium',
        color: 'text.secondary',
      }}
    >
      No Data Available
    </Box>
  );
};

const GstrPanValidationTables = () => {
  const [tableData, setTableData] = useState([]);
  const [logData, setLogData] = useState([]);
  const [exportLogData, setExportLogData] = useState([]);
  const [tableDataLoading, setTableDataLoading] = useState(false);
  const [fromDateMonthYearDisplay, setFromDateMonthYearDisplay] = useState(null);
  const [toDateMonthYearDisplay, setToDateMonthYearDisplay] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(0);
  const [formValues, setFormValues] = useState({
    invoiceType: 'Invoices',
  });
  const [checkboxState, setCheckboxState] = useState({
    gstin: false,
    pan: false,
  });
  const [selectedRows, setSelectedRows] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [currentLogId, setCurrentLogId] = useState(null);
  const [showThirdTable, setShowThirdTable] = useState(false);
  const thirdTableRef = useRef(null);
  const [entityType, setEntityType] = useState('');
  const [branchData, setBranchData] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [selectedMainBranch, setSelectedMainBranch] = useState('');
  const [isSelectFieldMandatory, setIsSelectFieldMandatory] = useState(false);

  // Columns definition
  const columns = [
    {
      field: 'LEGAL NAME',
      headerName: 'Customer Name',
      flex: 1,
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'GSTIN',
      headerName: 'GSTIN',
      flex: 1,
      minWidth: 200,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'PAN',
      headerName: 'PAN',
      flex: 0.7,
      minWidth: 120,
      pinned: 'left',
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'GSTIN VERIFY DATE',
      headerName: 'GSTIN Verify Date',
      flex: 1,
      minWidth: 180,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'GSTIN STATUS',
      headerName: 'GSTIN Status',
      flex: 1,
      minWidth: 180,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'PAN VERIFY DATE',
      headerName: 'PAN Verify Date',
      flex: 1,
      minWidth: 180,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'PAN STATUS',
      headerName: 'PAN Status',
      flex: 1,
      minWidth: 180,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'select',
      headerName: 'Select',
      flex: 1,
      minWidth: 200,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <Checkbox
            checked={selectedRows[params.id] || false}
            onChange={() => handleRowCheckboxChange(params.id)}
          />
        </div>
      ),
      filterable: false,
    },
  ];

  const logColumns = [
    {
      field: 'Legal Name',
      headerName: 'Legal Name',
      flex: 1,
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'GSTIN',
      headerName: 'GSTIN',
      flex: 1,
      minWidth: 200,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'GSTIN Status',
      headerName: 'GSTIN Status',
      flex: 0.7,
      minWidth: 120,
      pinned: 'left',
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'GSTIN Verify Date',
      headerName: 'GSTIN Verify Date',
      flex: 1,
      minWidth: 180,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'PAN',
      headerName: 'PAN',
      flex: 1,
      minWidth: 180,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'PAN Status',
      headerName: 'PAN Status',
      flex: 1,
      minWidth: 180,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'PAN Verify Date',
      headerName: 'PAN Verify Date',
      flex: 1,
      minWidth: 180,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
  ];

  const exportColumns = [
    {
      field: 'Type',
      headerName: 'Type',
      flex: 1,
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'From Date',
      headerName: 'From Date',
      flex: 1,
      minWidth: 200,
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'To Date',
      headerName: 'To Date',
      flex: 0.7,
      minWidth: 120,
      pinned: 'left',
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'Created At',
      headerName: 'Created At',
      flex: 0.7,
      minWidth: 120,
      pinned: 'left',
      align: 'center',
      headerAlign: 'center',
      filterable: true,
    },
    {
      field: 'actions',
      headerName: 'Action',
      flex: 1,
      minWidth: 200,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <div
          style={{
            display: 'flex',
            align: 'center',
            headerAlign: 'center',
            gap: '8px',
          }}
        >
          <VisibilityIcon style={{ cursor: 'pointer' }} onClick={() => viewSummaryLog(params.row.log_id)} />
        </div>
      ),
      filterable: false,
    },
  ];

  useEffect(() => {
    getUpdatedValidationData()
    const business_entity_id = localStorage.getItem('business_entity_id');
    const entity_type = localStorage.getItem('entity_type');
    setEntityType(entity_type);
    axios
      .get(`/multimonth_get_api/${business_entity_id}`)
      .then((res) => {
        const branchData = res.data;
        setBranchData(branchData);
        const entityChoices = branchData.map((entity) => ({
          value: entity.gstin,
          label: entity.entity_name,
        }));
        setBranchList(entityChoices);

        if (entity_type === 'Group') {
          setIsSelectFieldMandatory(true);
        } else {
          setIsSelectFieldMandatory(false);
        }
        if (entity_type === 'Main') {
          setSelectedMainBranch(branchData[0].gstin);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (showThirdTable && thirdTableRef.current) {
      thirdTableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [showThirdTable]);

  // Handle row checkbox change
  const handleRowCheckboxChange = (id) => {
    setSelectedRows((prev) => {
      const newSelectedRows = { ...prev, [id]: !prev[id] };
      const allSelected = tableData.every((row) => newSelectedRows[row.id]);
      setSelectAll(allSelected);
      return newSelectedRows;
    });
  };

  // Handle select all checkbox change
  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    const newSelectedRows = {};
    tableData.forEach((row) => {
      newSelectedRows[row.id] = newSelectAll;
    });
    setSelectedRows(newSelectedRows);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  // Custom Toolbar
  const CustomToolbar = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        height: '60px',
        flexWrap: 'wrap',
        gap: 1,
        padding: '3px 10px',
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      }}
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        <GridToolbarColumnsButton
          sx={{
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
          }}
        />
        <GridToolbarFilterButton
          sx={{
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
          }}
          PopperProps={{
            style: { zIndex: 1300 }, // Higher than typical Material-UI modals (1300 is above most default z-indices)
          }}
        />
        <GridToolbarDensitySelector
          sx={{
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
          }}
        />
      </Box>
      <Button style={{ height: '40px' }}>
        <Checkbox checked={selectAll} onChange={handleSelectAllChange} sx={{ alignSelf: 'center' }} />
        Select All
      </Button>
    </Box>
  );

  const CustomToolbar2 = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        height: '60px',
        flexWrap: 'wrap',
        gap: 1,
        padding: '3px 10px',
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      }}
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        <GridToolbarColumnsButton
          sx={{
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
          }}
        />
        <GridToolbarFilterButton
          sx={{
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
          }}
        />
        <GridToolbarDensitySelector
          sx={{
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
          }}
        />
      </Box>
    </Box>
  );

  const CustomToolbar3 = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        height: '60px',
        flexWrap: 'wrap',
        gap: 1,
        padding: '3px 10px',
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      }}
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        <GridToolbarColumnsButton
          sx={{
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
          }}
        />
        <GridToolbarFilterButton
          sx={{
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
          }}
        />
        <GridToolbarDensitySelector
          sx={{
            borderColor: '#1976d2',
            color: '#1976d2',
            borderRadius: '4px',
            padding: '2px 4px',
            '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 1, alignSelf: 'center' }}>
        {/* <Button
          style={{ height: '40px' }}
          size="small"
          variant="outlined"
          onClick={() => handleExportExcel(currentLogId)}
          disabled={!currentLogId}
        >
          Export
        </Button> */}
        <button
          style={{ marginTop: "0px", width: "100%", padding: "7px", height: '36px', }}
          className="button-primary"
          type="submit"
          onClick={() => handleExportExcel(currentLogId)}
          disabled={!currentLogId} // Add this to align with the form’s loading state
        >
        Export
        </button>
      </Box>
    </Box>
  );

  // Fetch data from API
  const fetchData = () => {
    if (!fromDateMonthYearDisplay || !toDateMonthYearDisplay) {
      setSnackbarMessage('Please select both From Date and To Date');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setTableDataLoading(false);
      return;
    }

    // Validate selectedMainBranch for Group entity type
    if (entityType === 'Group' && !selectedMainBranch) {
      setSnackbarMessage('Please select a Main Branch');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setTableDataLoading(false);
      return;
    }

    setTableDataLoading(true);
    let selectedEntity;
    const business_entity_id = localStorage.getItem('business_entity_id');
    if (entityType === 'Main' || branchData.length === 1) {
      selectedEntity = branchData[0];
    } else {
      selectedEntity = branchData.find((entity) => entity.gstin === selectedMainBranch);
    }

    // Determine main_branch_entity_id based on entityType
    const mainBranchEntityId =
      entityType === 'Main' ? branchData[0]?.business_entity_id : selectedEntity?.business_entity_id;

    const payload = {
      seller_code: business_entity_id, // Existing business entity ID
      main_branch_entity_id: mainBranchEntityId, // Selected branch's business_entity_id
      start_date: moment(fromDateMonthYearDisplay).format('YYYY-MM-DD'),
      end_date: moment(toDateMonthYearDisplay).format('YYYY-MM-DD'),
      fetch_function: formValues.invoiceType,
    };

    axios
      .post('/selecting_gstin_pan_validation', payload)
      .then((response) => {
        if (response.status === 200 && response.data?.data) {
          const dataWithIds = response.data.data.map((item, index) => ({
            ...item,
            id: item.UUID || `${currentPage}-${index}`, // Unique ID for each row
          }));
          setTableData(dataWithIds);
          setSelectedRows({});
          setSelectAll(false);
          if (dataWithIds.length > 0) {
            setSnackbarMessage('Data fetched successfully');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
          } else {
            setSnackbarMessage('No data found for the selected criteria');
            setSnackbarSeverity('info');
            setSnackbarOpen(true);
          }
        } else {
          throw new Error('Invalid response format');
        }
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || 'Error fetching data';
        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setTableData([]);
      })
      .finally(() => {
        setTableDataLoading(false);
      });
  };

  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const handleExportExcel = (LOG_ID) => {
    if (!LOG_ID) {
      setSnackbarMessage('No valid Log ID found for the selected row.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    const business_entity_id = localStorage.getItem('business_entity_id');
    // Find the selected branch's business_entity_id
    const selectedEntity = branchData.find((entity) => entity.gstin === selectedMainBranch);
    const mainBranchEntityId = selectedEntity?.business_entity_id;

    const payload = {
      seller_code: business_entity_id, // Existing business entity ID
      main_branch_entity_id: mainBranchEntityId, // Selected branch's business_entity_id
      log_id: LOG_ID,
    };

    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const filename = `GSTIN & Pan Validation -.xlsx`;

    axios
      .post('/gst_pan_excel_api', payload)
      .then((res) => {
        if (res?.data?.file) {
          downloadBase64File(contentType, res.data.file, filename);
          setSnackbarMessage('Excel file downloaded successfully.');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
        } else {
          throw new Error('No file data in response.');
        }
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.message || 'Error exporting Excel file.';
        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  };

  // Handle form submission
  const onSubmitHandler = () => {
    setSubmitLoading(true);
    fetchData(); // Initial fetch with page 0
    setSubmitLoading(false);
  };

  // Handle checkbox changes for GSTIN/PAN filters
  const handleCheckboxChange = (name) => {
    setCheckboxState((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // Clear all filter checkboxes
  const handleClearAll = () => {
    setCheckboxState({
      gstin: false,
      pan: false,
    });
  };

  // Send selected data to API
  const handleSendSelectedData = () => {
    const selectedRowIds = Object.keys(selectedRows).filter((id) => selectedRows[id]);
    const selectedRowsData = tableData.filter((row) => selectedRowIds.includes(String(row.id)));

    if (selectedRowsData.length === 0) {
      setSnackbarMessage('No rows selected. Please select at least one row.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    // Validate date inputs
    if (!fromDateMonthYearDisplay || !toDateMonthYearDisplay) {
      setSnackbarMessage('Please select both From Date and To Date.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    // Validate selectedMainBranch for Group entity type
    if (entityType === 'Group' && !selectedMainBranch) {
      setSnackbarMessage('Please select a Main Branch');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    const business_entity_id = localStorage.getItem('business_entity_id');
    // Find the selected branch's business_entity_id
    const selectedEntity = branchData.find((entity) => entity.gstin === selectedMainBranch);
    const mainBranchEntityId = selectedEntity?.business_entity_id;

    const payload = {
      seller_code: business_entity_id, // Existing business entity ID
      main_branch_entity_id: mainBranchEntityId, // Selected branch's business_entity_id
      type: formValues.invoiceType,
      start_date: moment(fromDateMonthYearDisplay).format('YYYY-MM-DD'),
      end_date: moment(toDateMonthYearDisplay).format('YYYY-MM-DD'),
    };

    // Handle log_id (UUID)
    payload.log_id = selectedRowsData.filter((row) => row.UUID).map((row) => row.UUID);

    // Handle GSTIN
    if (checkboxState.gstin) {
      payload.gstin_list = selectedRowsData.filter((row) => row.GSTIN).map((row) => row.GSTIN);
    }

    // Handle PAN
    if (checkboxState.pan) {
      payload.pan_list = selectedRowsData.filter((row) => row.PAN).map((row) => row.PAN);
    }

    // Validate payload
    if (
      (!payload.gstin_list || payload.gstin_list.length === 0) &&
      (!payload.pan_list || payload.pan_list.length === 0) &&
      (!payload.log_id || payload.log_id.length === 0)
    ) {
      setSnackbarMessage(
        'No valid GSTIN, PAN, or Log ID data selected. Please check at least one checkbox and select rows with valid data.'
      );
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    console.log('Sending payload:', payload);

    axios
      .post('/gst_pan_combined_api', payload)
      .then((response) => {
        const refreshPayload = {
          start_date: moment(fromDateMonthYearDisplay).format('YYYY-MM-DD'),
          end_date: moment(toDateMonthYearDisplay).format('YYYY-MM-DD'),
          seller_code: business_entity_id, // Existing business entity ID
          main_branch_entity_id: mainBranchEntityId, // Selected branch's business_entity_id
          fetch_function: formValues.invoiceType,
        };

        axios
          .post('/selecting_gstin_pan_validation', refreshPayload)
          .then((refreshResponse) => {
            if (refreshResponse.status === 200 && refreshResponse.data.data) {
              const dataWithIds = refreshResponse.data.data.map((item, index) => ({
                ...item,
                id: index + 1,
              }));
              setTableData(dataWithIds);
              setSelectedRows({});
              setSelectAll(false);
              getUpdatedValidationData();
              if (dataWithIds.length > 0) {
                setSnackbarMessage('Table refreshed successfully');
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
              }
            } else {
              throw new Error('No data found in response');
            }
          })
          .catch((error) => {
            const errorMessage = error.response?.data?.message || 'Error refreshing table data';
            setSnackbarMessage(errorMessage);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
          });
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || 'Error sending data';
        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  };

  const getUpdatedValidationData = () => {
    const business_entity_id = localStorage.getItem('business_entity_id');
    // Find the selected branch's business_entity_id
    const selectedEntity = branchData.find((entity) => entity.gstin === selectedMainBranch);
    const mainBranchEntityId = selectedEntity?.business_entity_id;

    const payload = {
      seller_code: business_entity_id, // Existing business entity ID
      // main_branch_entity_id: mainBranchEntityId, // Selected branch's business_entity_id
    };

    axios
      .post('/gst_pan__summary_api', payload)
      .then((response) => {
        if (response.data.data.length === 0 && response.data.total_records === 0) {
          setExportLogData([]);
        } else {
          const dataWithIds = response.data.data.map((item, index) => ({
            ...item,
            id: item.UUID || `log-${index}`,
          }));
          setExportLogData(dataWithIds);
        }
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || 'Error sending data';
        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  };

  const viewSummaryLog = (log_id) => {
    console.log(log_id);
    setCurrentLogId(log_id);
    getUpdatedValidationExporViewData(log_id);
  };

  const getUpdatedValidationExporViewData = (log_id) => {
    const business_entity_id = localStorage.getItem('business_entity_id');
    // Find the selected branch's business_entity_id
    const selectedEntity = branchData.find((entity) => entity.gstin === selectedMainBranch);
    const mainBranchEntityId = selectedEntity?.business_entity_id;

    const payload = {
      seller_code: business_entity_id, // Existing business entity ID
      main_branch_entity_id: mainBranchEntityId, // Selected branch's business_entity_id
      log_id: log_id,
    };

    axios
      .post('/gst_pan_history_table_api', payload)
      .then((response) => {
        if (response.data.error) {
          setSnackbarMessage(response.data.error || 'Error in response');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
          setLogData([]);
          setShowThirdTable(false);
          return;
        }

        const dataWithIds = response.data.data.map((item, index) => ({
          ...item,
          id: item.UUID || `log-${index}`,
        }));
        setLogData(dataWithIds);
        setShowThirdTable(dataWithIds.length > 0);

        if (dataWithIds.length > 0 && thirdTableRef.current) {
          thirdTableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || error.response?.data?.error || 'Error sending data';
        setSnackbarMessage(errorMessage);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLogData([]);
        setShowThirdTable(false);
      });
  };

  // Date picker handlers
  const inputHandlerFromDatePicker = (date) => {
    setFromDateMonthYearDisplay(date);
  };

  const inputHandlerToDatePicker = (date) => {
    setToDateMonthYearDisplay(date);
  };

  // Reset state when invoiceType changes (but not for selectedMainBranch)
  useEffect(() => {
    setFromDateMonthYearDisplay(null);
    setToDateMonthYearDisplay(null);
    setTableData([]);
    setSelectedRows({});
    setSelectAll(false);
    setCheckboxState({
      gstin: false,
      pan: false,
    });
    setTableDataLoading(false);
    setSubmitLoading(false);
    setSnackbarOpen(false);
    setSnackbarMessage('');
  }, [formValues.invoiceType]); // Only trigger on invoiceType change

  // Handle getUpdatedValidationData when selectedMainBranch changes
  useEffect(() => {
    // if (selectedMainBranch) {
    getUpdatedValidationData();
    // }
  }, []); // Trigger only on selectedMainBranch change

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        marginTop: '0%',
        marginLeft: '0%',
        marginBottom: '4px',
        flexWrap: 'wrap',
      }}
    >
      <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 0 }}>
          Gstin & Pan Validation
        </Typography>
        <ValidatorForm useRef="form" onSubmit={onSubmitHandler} onError={(errors) => console.log(errors)}>
          <Grid container>
            <Grid item xs={12}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  marginTop: '0%',
                  marginLeft: '0%',
                  marginBottom: '20px',
                  flexWrap: 'wrap',
                }}
              >
                <FormControl variant="outlined" size="small" sx={{ width: '200px', marginTop: '2%' }}>
                  <InputLabel id="invoice-type-label">Document Type</InputLabel>
                  <Select
                    labelId="invoice-type-label"
                    id="invoice-type"
                    value={formValues.invoiceType}
                    onChange={(e) =>
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        invoiceType: e.target.value,
                      }))
                    }
                    label="Document Type"
                  >
                    <MenuItem value="Invoices">Invoice</MenuItem>
                    <MenuItem value="Bills">Bills</MenuItem>
                  </Select>
                </FormControl>
                <div style={{ minWidth: '200px' }}>
                  <label style={{ margin: 0, fontWeight: 500 }}>
                    From Date<span style={{ color: 'red' }}>*</span>:
                  </label>
                  <ValidatedDatePicker
                    placeholder="From Date"
                    errorMessages={['This field is required']}
                    validators={['required']}
                    value={fromDateMonthYearDisplay ?? ''}
                    onChange={inputHandlerFromDatePicker}
                    style={{ width: '150px', marginTop: '8px' }}
                  />
                </div>
                <div style={{ minWidth: '200px' }}>
                  <label style={{ margin: 0, fontWeight: 500 }}>
                    To Date<span style={{ color: 'red' }}>*</span>:
                  </label>
                  <ValidatedDatePicker
                    minDateForDatepicker={fromDateMonthYearDisplay ?? ''}
                    placeholder="To Date"
                    errorMessages={['This field is required']}
                    validators={['required']}
                    value={toDateMonthYearDisplay ?? ''}
                    onChange={inputHandlerToDatePicker}
                    style={{ width: '150px', marginTop: '8px' }}
                  />
                </div>
                {entityType === 'Group' && (
                  <Grid item xs={3} sm={3} md={3}>
                    <SelectField
                      SelectLabel="Main Branch"
                      placeholder="Select Main branch"
                      validator={isSelectFieldMandatory ? ['required'] : []}
                      errorMsg={isSelectFieldMandatory ? ['This field is required'] : []}
                      choice_id="value"
                      choice_name="label"
                      choices={[{ value: '' }, ...branchList]}
                      name="main_branch"
                      value={selectedMainBranch || ''}
                      textOnchangeFunction={(e) => setSelectedMainBranch(e.target.value)}
                    />
                  </Grid>
                )}
                {/* <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className="button-primary"
                  style={{ height: '36px', marginTop: '16px', padding: '6px 16px' }}
                  disabled={submitLoading}
                >
                  SUBMIT
                </Button> */}
                {canWrite("GSTIN & PAN VALIDATION") && (
                <button
                  style={{ marginTop: "20px", width: "6%", padding: "7px", height: '36px', }}
                  className="button-primary"
                  type="submit"
                    disabled={submitLoading}
                >
                  Submit
                </button>
                )}
              </div>
            </Grid>
          </Grid>
        </ValidatorForm>
        <Box sx={{ p: 0.5, margin: 'auto', display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'nowrap',
              width: '100%',
            }}
          >
            <FormControlLabel
              control={<Checkbox checked={checkboxState.gstin} onChange={() => handleCheckboxChange('gstin')} />}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ fontSize: 12 }}>GSTIN</div>
                  <InfoOutlinedIcon sx={{ fontSize: 16, ml: 1, color: 'text.secondary' }} />
                </Box>
              }
              sx={{ m: 0 }}
            />
            <FormControlLabel
              control={<Checkbox checked={checkboxState.pan} onChange={() => handleCheckboxChange('pan')} />}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ fontSize: 12 }}>PAN</div>
                  <InfoOutlinedIcon sx={{ fontSize: 16, ml: 1, color: 'text.secondary' }} />
                </Box>
              }
              sx={{ m: 0 }}
            />
            <Button
              variant="outlined"
              sx={{
                color: 'text.secondary',
                textTransform: 'none',
                height: '32px',
                minWidth: '80px',
                borderColor: 'text.secondary',
                '&:hover': {
                  bgcolor: '#f5f5f5',
                  borderColor: 'text.secondary',
                },
              }}
              onClick={handleClearAll}
            >
              Clear All
            </Button>
            {canWrite("GSTIN & PAN VALIDATION") && (
            <Button
              variant="outlined"
              sx={{
                textTransform: 'none',
                color: '#4A4A6D',
                borderColor: '#4A4A6D',
                height: '32px',
                minWidth: '100px',
                '&:hover': {
                  bgcolor: '#4A4A6D',
                  borderColor: '#1565c0',
                     color: 'white',
                },
              }}
              onClick={handleSendSelectedData}
              disabled={
                Object.keys(selectedRows).filter((id) => selectedRows[id]).length === 0 ||
                (!checkboxState.gstin && !checkboxState.pan)
              }
            >
              Submit
            </Button>
            )}
          </Box>
        </Box>
        <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
          <DataGridPro
            rows={tableData}
            columns={columns}
            loading={tableDataLoading}
            pagination
            pageSize={pageSize}
            pageSizeOptions={[5, 10, 25, 50]}
            onPageSizeChange={handlePageSizeChange}
            onPageChange={handlePageChange}
            disableRowSelectionOnClick={true}
            onRowSelectionModelChange={() => { }}
            localeText={{
              toolbarDensity: 'Size',
              toolbarDensityLabel: 'Size',
              toolbarDensityCompact: 'Small',
              toolbarDensityStandard: 'Medium',
              toolbarDensityComfortable: 'Large',
              footerRowSelected: () => '',
            }}
            sx={{
              maxHeight: '65vh',
              '& .MuiDataGrid-columnHeaders': {
                color: '#fff',
                fontWeight: 'bold',
                cursor: 'pointer',
                textAlign: 'right',
                zIndex: 1000,
              },
              '& .MuiDataGrid-columnHeader': {
                position: 'relative',
                textAlign: 'right',
                width: '100%',
                fontWeight: 'bold',
                backgroundColor: '#607d8b',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                color: '#fff',
              },
              '& .MuiDataGrid-sortIcon': {
                opacity: 'inherit !important',
              },
              '& .MuiDataGrid-iconButtonContainer': {
                visibility: 'visible',
              },
              '& .MuiDataGrid-menuIconButton': {
                opacity: '1 !important',
                visibility: 'visible !important',
                display: 'flex !important',
              },
              '& .MuiDataGrid-columnHeaderIcon': {
                color: '#fff',
              },
              '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                color: '#fff',
              },
              '& .MuiDataGrid-row:nth-of-type(odd)': {
                backgroundColor: '#f9f9f9',
              },
              '& .MuiDataGrid-row:nth-of-type(even)': {
                backgroundColor: '#ffffff',
              },
              '& .MuiDataGrid-cell': {
                padding: '8px',
                textAlign: 'center',
              },
              '& .MuiDataGrid-footerContainer': {
                backgroundColor: '#f0f0f0',
              },
              '& .MuiCheckbox-root': {
                color: '#1976d2',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#d3e3fc',
                cursor: 'pointer',
              },
            }}
            components={{
              Toolbar: CustomToolbar,
              NoRowsOverlay: CustomNoRowsOverlay,
            }}
          />
        </Box>
        <Box sx={{ height: '65vh', width: '100%', marginTop: '20px' }}>
          <DataGridPro
            rows={exportLogData}
            columns={exportColumns}
            loading={tableDataLoading}
            pagination
            pageSize={pageSize}
            pageSizeOptions={[5, 10, 25, 50]}
            onPageSizeChange={handlePageSizeChange}
            onPageChange={handlePageChange}
            localeText={{
              toolbarDensity: 'Size',
              toolbarDensityLabel: 'Size',
              toolbarDensityCompact: 'Small',
              toolbarDensityStandard: 'Medium',
              toolbarDensityComfortable: 'Large',
              footerRowSelected: () => '',
            }}
            sx={{
              maxHeight: '65vh',
              '& .MuiDataGrid-columnHeaders': {
                color: '#fff',
                fontWeight: 'bold',
                cursor: 'pointer',
                textAlign: 'right',
                zIndex: 1000,
              },
              '& .MuiDataGrid-columnHeader': {
                position: 'relative',
                textAlign: 'right',
                width: '100%',
                fontWeight: 'bold',
                backgroundColor: '#607d8b',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                color: '#fff',
              },
              '& .MuiDataGrid-sortIcon': {
                opacity: 'inherit !important',
              },
              '& .MuiDataGrid-icon SNAPSHOTButtonContainer': {
                visibility: 'visible',
              },
              '& .MuiDataGrid-menuIconButton': {
                opacity: '1 !important',
                visibility: 'visible !important',
                display: 'flex !important',
              },
              '& .MuiDataGrid-columnHeaderIcon': {
                color: '#fff',
              },
              '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                color: '#fff',
              },
              '& .MuiDataGrid-row:nth-of-type(odd)': {
                backgroundColor: '#f9f9f9',
              },
              '& .MuiDataGrid-row:nth-of-type(even)': {
                backgroundColor: '#ffffff',
              },
              '& .MuiDataGrid-cell': {
                padding: '8px',
                textAlign: 'center',
              },
              '& .MuiDataGrid-footerContainer': {
                backgroundColor: '#f0f0f0',
              },
              '& .MuiCheckbox-root': {
                color: '#1976d2',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#d3e3fc',
                cursor: 'pointer',
              },
            }}
            components={{
              Toolbar: CustomToolbar2,
              NoRowsOverlay: CustomNoRowsOverlay,
            }}
          />
        </Box>

        {showThirdTable && (
          <Box ref={thirdTableRef} sx={{ height: '65vh', width: '100%', marginTop: '20px' }}>
            <DataGridPro
              rows={logData}
              columns={logColumns}
              loading={tableDataLoading}
              pagination
              pageSize={pageSize}
              pageSizeOptions={[5, 10, 25, 50]}
              onPageSizeChange={handlePageSizeChange}
              onPageChange={handlePageChange}
              rowSelection={false}
              localeText={{
                toolbarDensity: 'Size',
                toolbarDensityLabel: 'Size',
                toolbarDensityCompact: 'Small',
                toolbarDensityStandard: 'Medium',
                toolbarDensityComfortable: 'Large',
              }}
              sx={{
                maxHeight: '65vh',
                '& .MuiDataGrid-columnHeaders': {
                  color: '#fff',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  textAlign: 'right',
                  zIndex: 1000,
                },
                '& .MuiDataGrid-columnHeader': {
                  position: 'relative',
                  textAlign: 'right',
                  width: '100%',
                  fontWeight: 'bold',
                  backgroundColor: '#607d8b',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  color: '#fff',
                },
                '& .MuiDataGrid-sortIcon': {
                  opacity: 'inherit !important',
                },
                '& .MuiDataGrid-iconButtonContainer': {
                  visibility: 'visible',
                },
                '& .MuiDataGrid-menuIconButton': {
                  opacity: '1 !important',
                  visibility: 'visible !important',
                  display: 'flex !important',
                },
                '& .MuiDataGrid-columnHeaderIcon': {
                  color: '#fff',
                },
                '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                  color: '#fff',
                },
                '& .MuiDataGrid-row:nth-of-type(odd)': {
                  backgroundColor: '#f9f9f9',
                },
                '& .MuiDataGrid-row:nth-of-type(even)': {
                  backgroundColor: '#ffffff',
                },
                '& .MuiDataGrid-cell': {
                  padding: '8px',
                  textAlign: 'center',
                },
                '& .MuiDataGrid-footerContainer': {
                  backgroundColor: '#f0f0f0',
                },
                '& .MuiCheckbox-root': {
                  color: '#1976d2',
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#d3e3fc',
                  cursor: 'pointer',
                },
              }}
              components={{
                Toolbar: CustomToolbar3,
                NoRowsOverlay: CustomNoRowsOverlay,
              }}
            />
          </Box>
        )}
      </Container>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default GstrPanValidationTables;